import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";

const Issuesinorder = ({ workOrderDetail }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [issues, setIssues] = useState([]);
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueType;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issuePriority;

  const getVehicleIssues = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleissues?vehicleRegistration=${workOrderDetail?.vehicleRegistrationNo}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setIssues(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    }
  };

  useEffect(() => {
    if (workOrderDetail?.vehicleRegistrationNo) {
      getVehicleIssues();
    }
  }, [workOrderDetail]);

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {issues.length > 0 ? (
          issues.map((data) => (
            <div className="bg-white shadow-sm rounded-xl p-4 w-full max-w-sm border">
              <p className="text-sm text-black mb-2">{data?.summary}</p>
              <div className="text-sm text-gray-600 space-y-1">
                <p>
                  <span className="text-black">Issue Id:</span> {data?.code}
                </p>
                <p>
                  <span className="text-black">Priority:</span>{" "}
                  {issuePriority[data?.priority]}
                </p>
                <p>
                  <span className="text-black">Status:</span>{" "}
                  {issueStatus[data?.status]}
                </p>
                <p>
                  <span className="text-black">Type:</span>{" "}
                  {issueType[data?.type]}
                </p>
                <p>
                  <span className="text-black">Description:</span>{" "}
                  {data?.description}
                </p>
                <p>
                  <span className="text-black">City:</span> {data?.cityText}
                </p>
                <p>
                  <span className="text-black">Cost:</span> ₹{data?.totalCost}
                </p>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <button className="px-4 py-2 text-white text-sm font-medium rounded-lg bg-green-700 hover:bg-green-600 transition border border-green-600">
                  Tag
                </button>

                <button className="px-4 py-2 text-sm text-white font-medium rounded-lg bg-blue-600 hover:bg-blue-500 transition">
                  View Details
                </button>
              </div>
            </div>
          ))
        ) : (
          <>No issues found.</>
        )}
      </div>
    </div>
  );
};

export default Issuesinorder;
